import {useSelector} from "react-redux";
import {RootState} from "../reducers";
import {GWTVersionEnum} from "../constants";

/**
 * Determines whether to use GWT version 2 based on the authentication state (of logged-in user).
 *
 * This function retrieves the authentication state from the Redux store
 * and analyzes the user client's `gwtVersion` property to check if it matches
 * the value for GWT version 2.
 *
 * @returns {boolean} `true` if the user's client `gwtVersion` is set to version 2, otherwise `false`.
 */
export const useGwtV2 = (): boolean => {
    const auth: any = useSelector((state: RootState) => state.auth);
    return !!(auth && auth.user && auth.user.client && auth.user.client.gwtVersion && auth.user.client.gwtVersion === GWTVersionEnum.Two);
}